import Vue from "vue";
import { intl } from "@/helpers";

Vue.filter("emptyNumber", function(value) {
  if (value === 0) {
    return "";
  } else {
    return value;
  }
});

Vue.filter("date", function(value) {
  const moment = require("moment");
  const date = moment(value);
  if (date.isValid()) {
    return date.format("DD.MM.YY");
  }
  return "";
});

Vue.filter("monthYear", function(value) {
  const moment = require("moment");
  const monthYear = moment(value);
  if (monthYear.isValid()) {
    return monthYear.format("MMMM YYYY");
  }
  return "";
});

Vue.filter("dateTime", function(value) {
  const moment = require("moment");
  const dateTime = moment(value);
  if (dateTime.isValid()) {
    return dateTime.format("DD.MM.YY HH:mm");
  }
  return "";
});

Vue.filter("decimal", function(value) {
  return intl.formatNumberRu(value.toFixed(2));
});

Vue.filter("number", function(value) {
  return intl.formatNumberRu(value);
});

Vue.filter("cropText", function(value, limit) {
  if (value.length > limit) {
    return value.substring(0, limit) + "...";
  }
  return value;
});

Vue.filter("catalog", function(value) {
  if (!value) {
    return "";
  }
  if (!value.title) {
    return "";
  }
  return value.title;
});

Vue.filter("secondsToHours", function(value) {
  return (value / 3600).toFixed(0);
});